export const RANKED_PRODUCTS_DATA = {
  "25-lowest-phosphorus-foods-without-prescription": {
    "generatedAt": "2026-04-13T22:35:04.399Z",
    "sourceApiUrl": "http://localhost:5000/api/data",
    "totalMatches": 474,
    "products": [
      {
        "sourceId": "weruva.com_products_tilapia-and-chicken-formula-in-a-hydrating-puree-cat-can",
        "rank": 1
      },
      {
        "sourceId": "weruva.com_products_tilapia-and-tuna-formula-in-a-hydrating-puree-cat-can",
        "rank": 2
      },
      {
        "sourceId": "weruva.com_products_chicken-and-tilapia-formula-in-gravy-cat-can",
        "rank": 3
      },
      {
        "sourceId": "weruva.com_products_chicken-formula-in-a-hydrating-puree-cat-can",
        "rank": 4
      },
      {
        "sourceId": "weruva.com_products_chicken-formula-in-gravy-cat-can",
        "rank": 5
      },
      {
        "sourceId": "weruva.com_products_chicken-tilapia-freeze-dried-cat",
        "rank": 6
      },
      {
        "sourceId": "youngagainpetfood.com_products_zero-mature-health",
        "rank": 7
      },
      {
        "sourceId": "hillspet.com_cat-food_science-diet-adult-chunks-gravy-tuna-tender-dinner-canned",
        "rank": 8
      },
      {
        "sourceId": "youngagainpetfood.com_products_lid-zero-mature-health",
        "rank": 9
      },
      {
        "sourceId": "youngagainpetfood.com_products_sensitive-stomach-cat",
        "rank": 10
      },
      {
        "sourceId": "wellnesspetfood.com_product-catalog_wellness-complete-health-healthy-indulgence-morsels-chicken-chicken-liver",
        "rank": 11
      },
      {
        "sourceId": "weruva.com_products_pamper-like-paris-tuna-beef-salmon-gravy-cat-can",
        "rank": 12
      },
      {
        "sourceId": "wellnesspetfood.com_product-catalog_wellness-complete-health-healthy-indulgence-morsels-chicken-salmon",
        "rank": 13
      },
      {
        "sourceId": "hillspet.com_cat-food_science-diet-senior-11-healthy-cuisine-tuna-carrot-med-stew-canned",
        "rank": 14
      },
      {
        "sourceId": "hillspet.com_cat-food_science-diet-adult-tender-tuna-dinner-pouch",
        "rank": 15
      },
      {
        "sourceId": "weruva.com_products_steak-frites-dinner-cat-can",
        "rank": 16
      },
      {
        "sourceId": "hillspet.com_cat-food_science-diet-adult-healthy-cuisine-chicken-rice-medley-stew-canned",
        "rank": 17
      },
      {
        "sourceId": "hillspet.com_cat-food_science-diet-adult-chunks-gravy-chicken-tender-dinner-canned",
        "rank": 18
      },
      {
        "sourceId": "wellnesspetfood.com_product-catalog_wellness-complete-health-healthy-indulgence-morsels-salmon-tuna",
        "rank": 19
      },
      {
        "sourceId": "weruva.com_products_pamper-like-paris-salmon-tuna-gravy-cat-can",
        "rank": 20
      },
      {
        "sourceId": "youngagainpetfood.com_products_mature-health",
        "rank": 21
      },
      {
        "sourceId": "wellnesspetfood.com_product-catalog_wellness-complete-health-healthy-indulgence-morsels-chicken-turkey",
        "rank": 22
      },
      {
        "sourceId": "wellnesspetfood.com_product-catalog_wellness-complete-health-healthy-indulgence-morsels-tuna",
        "rank": 23
      },
      {
        "sourceId": "hillspet.com_cat-food_science-diet-mature-adult-7-healthy-cuisine-chicken-rice-med-stew-canned",
        "rank": 24
      },
      {
        "sourceId": "hillspet.com_cat-food_science-diet-adult-seafood-canned",
        "rank": 25
      }
    ]
  }
};
